<ui-panel
  class="case-context-record-grid"
  width="fill"
  [panelTitle]="heading"
  [title]="heading"
>
  <ng-template #recordActions let-record>
    <button uiButton type="button" [attr.aria-label]="'View ' + recordTitle(record) + ' details'" (click)="openDetails(record)">View</button>
  </ng-template>
  <div class="case-context-record-grid__body" [attr.aria-busy]="state === 'loading'">
    <p *ngIf="state === 'loading'" class="case-context-record-grid__state" role="status">
      {{ loadingText }}
    </p>

    <p *ngIf="state === 'error'" class="case-context-record-grid__state case-context-record-grid__state--error" role="alert">
      {{ errorText }}
    </p>

    <p *ngIf="state === 'empty'" class="case-context-record-grid__state">
      {{ emptyText }}
    </p>

    <ui-grid
      *ngIf="state === 'ready' && records.length > 0"
      width="fill"
      containerClass="no-panel"
      [rowData]="records"
      [columnDefs]="viewColumns"
      [defaultColDef]="defaultColDef"
      [agGridOptions]="agGridOptions"
      [pageSizes]="pageSizes"
      [rowHeight]="rowHeight"
      [noRowsHeight]="noRowsHeight"
      [showPanelHeader]="false"
      [autoHidePaginator]="true"
      [showBlankRowsOnLastPage]="true"
      class="case-context-record-grid__table"
    ></ui-grid>

    <p *ngIf="state === 'ready' && records.length === 0" class="case-context-record-grid__state">
      {{ emptyText }}
    </p>
  </div>
</ui-panel>
@if (selected; as record) {
  <app-record-details-flyout
    [title]="detailTitle" [summary]="record.summary" [fields]="detailFields(record)"
    (closed)="selected = null"
  />
}
